import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Col, Row, Modal, Table } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import {
  addItem,
  editItem,
  fetchId,
  fetchIdNoloading,
  selectId,
  selectLoading,
  uploadItem,
  uploadValidate,
} from "./roleSlice";
import { useHistory, useParams } from "react-router";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  CallApi,
  showDialog,
  formatterStatus,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { Marker } from "../../utility/Marker";
import GoogleMapReact from "google-map-react";
import Select from "react-select";
import { selectUser } from "../../modules/Auth/_redux/authRedux";
import { headerSortingClasses, sortCaret } from "../../../_metronic/_helpers";
import BootstrapTable from "react-bootstrap-table-next";
import { fetchTemplate, selectLoadingTemplate } from "../product/productSlice";

export const RoleCreate = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const loading2 = useSelector(selectLoadingTemplate);
  const user = useSelector(selectUser);
  const dataId = useSelector(selectId);
  const { id } = useParams();
  const ref = useRef();

  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [permissions, setPermissions] = useState([]);

  const paramsId = {
    role_id: id,
  };

  useEffect(() => {
    async function fetchMyAPI() {
      if (id !== undefined) {
        await CallApi(paramsId, fetchId, dispatch);
      }
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataId) {
      setName(dataId.role_name);
      setCode(dataId.role_code);

      const initData = dataId.permissions.map((item, index) => {
        return {
          ...item,
          no: index + 1,
        };
      });

      setPermissions(initData);
    }
  }, [dataId]);

  const handleSave = async () => {
    const params = {
      role_id: id,
      role_name: dataId.role_name,
      role_code: dataId.role_code,
      permissions: permissions,
    };

    console.log(params, "params");
    try {
      const response =
        id === undefined
          ? await dispatch(addItem(params))
          : await dispatch(editItem(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchIdNoloading, dispatch);
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const handleCheckboxChange = (roleId, permType) => {
    setPermissions((prevPermissions) =>
      prevPermissions.map((item) =>
        item.role_permission_id === roleId
          ? { ...item, [permType]: !item[permType] }
          : item
      )
    );
  };

  const handleAllChange = (roleId) => {
    setPermissions((prevPermissions) =>
      prevPermissions.map((item) => {
        if (item.role_permission_id === roleId) {
          const allPermissionsChecked = Object.keys(item).every(
            (key) => !key.endsWith("_perm") || item[key]
          );
          const updatedItem = {};
          Object.keys(item).forEach((key) => {
            if (key.endsWith("_perm")) {
              updatedItem[key] = !allPermissionsChecked;
            }
          });
          return { ...item, ...updatedItem };
        }
        return item;
      })
    );
  };

  return loading || loading2 ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title">
            {id === undefined
              ? "Create Role Permision"
              : `Edit Role Permision ${dataId?.role_name} `}
          </CardHeaderTitle>
          <CardHeaderToolbar>
            <Button
              className="btn btn-secondary mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>

            <Button
              className="btn btn-danger"
              onClick={(e) => {
                handleSave();
              }}
            >
              Save
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          {permissions && permissions.length > 0 ? (
            <Table striped bordered>
              <thead style={{ backgroundColor: "#EF4444", color: "#fff" }}>
                <tr>
                  <th>Menu</th>
                  <th>Permission</th>
                  <th>All</th>
                </tr>
              </thead>
              <tbody>
                {permissions.map((item) => (
                  <tr key={item.role_permission_id}>
                    <td>
                      <label>
                        <b>{item.menu_title}</b>
                      </label>
                    </td>
                    <td>
                      {[
                        "view_perm",
                        "create_perm",
                        "edit_perm",
                        "delete_perm",
                        "cancel_perm",
                        "checker_perm",
                        "export_perm",
                        "import_perm",
                      ].map((permType) => (
                        <label key={permType} className="">
                          <b> {permType.replace("_perm", "")}:</b>
                          <input
                            type="checkbox"
                            className="mr-3 ml-3 mt-5"
                            style={{ marginRight: "10px" }}
                            checked={item[permType]}
                            onChange={() =>
                              handleCheckboxChange(
                                item.role_permission_id,
                                permType
                              )
                            }
                          />
                        </label>
                      ))}
                    </td>
                    <td>
                      <label className="mr-4">
                        <input
                          type="checkbox"
                          className="mr-3 mt-3"
                          checked={Object.keys(item).every(
                            (key) => !key.endsWith("_perm") || item[key]
                          )}
                          onChange={() =>
                            handleAllChange(item.role_permission_id)
                          }
                        />
                        <b className="pr-4">ALL</b>
                      </label>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : null}
        </CardBody>
      </Card>
    </>
  );
};
